module.exports = {
	"header": "Paramètres de l'accès du personnel",
	"activeUsersH2": "Employés actifs",
	"activeUsersOwner": "Propriétaire",
	"activeUsersP": "Les utilisateurs suivants ont accès à ce compte d'encanteur:",
	"activeUsersThEmails": "Courriel(s)",
	"inviteUserBtn": "Inviter un employé",
	"newInviteModalEmailLabel": "Envoyer une invitation à gérer ce compte d'encanteur à l'adresse électronique suivante:",
	"newInviteModalEmailPlaceholder": "contact@exemple.com",
	"newInviteModalTitle": "Inviter un nouvel utilisateur",
	"noPendingInvites": "Il n'y a pas d'invitations d'employé en attente.",
	"pendingInvitesH2": "Invitations d'employé en attente",
	"pendingInvitesP": "Les adresses courriel suivantes ont une invitation d'employé en attente pour ce compte d'encanteur:",
	"pendingInvitesThInviteDate": "Invitation envoyée le",
	"removeAccessModalRemoveAccessBtn": "Retirer l'accès",
	"removeAccessModalEmailLabel": "Êtes-vous certain de vouloir retirer l'accès à cet employé?",
	"removeAccessModalTitle": "Retirer l'accès à l'employé pour ce compte d'encanteur"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/oa-staffAccess.json5
// module id = 1999
// module chunks = 6